/**
 * Created by jonas on 2019-08-21.
 */
import {Timeline, TimelineLite, Linear} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {IBuffaloWinRatioConfig} from "../../WinterHoardGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";

export class BigWinStep implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _fromRatioConfig:IBuffaloWinRatioConfig;
    private _toRatioConfig:IBuffaloWinRatioConfig;
    private _hasWin:boolean;
    private _countFrom:number;
    private _countTo:number;
    private _lastLevel:boolean;
    private _lastLevelCount:number;
    //private _ease:CustomEase;
    private _winRatios: IWinRatioConfig[];
    private _winLevel: number;
    private _gameMode: string;
    private _bData:WinterHoardParsedGameData;

    constructor(fromRatioConfig:IBuffaloWinRatioConfig, toRatioConfig:IBuffaloWinRatioConfig, stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
        this._winRatios = GameConfig.instance.WIN_RATIOS.bigWin;
    }

    public prepare(data:ParsedGameData):void {
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;
        this._gameMode = data.mode;
        this._bData = <WinterHoardParsedGameData> data;

        if(data instanceof ParsedGameData) {
            if(data.singleWin <= 0) {
                return;
            }

            //debugger;
            const currentWinRatio = this._bData.totalSpinWinnings / data.playedBetValue;
            let winRatios: number = data.currentWinRatio;
            this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
            this._countTo = Math.min(data.playedBetValue * this._toRatioConfig.ratio, data.singleWin);
            this._hasWin = data.isBigWin && (data.playedBetValue * this._toRatioConfig.ratio<=data.singleWin);
            if((data.currentWinRatioConfig && data.currentWinRatioConfig == this._toRatioConfig)) {
                this._lastLevel = true;
                this._lastLevelCount = data.singleWin;
            }
            this._winLevel = -1;
            for (let i: number = this._winRatios.length - 1; i >= 0; i--) {
                if (winRatios > this._winRatios[i].ratio) {
                    this._winLevel = i;
                    return;
                }
            }
            // if the winRation is exactly 15
            this._winLevel = -1;
        }
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }
        const type:WinRatioType = this._toRatioConfig.type!;
        const tl:TimelineLite = new TimelineLite();
        let level:number = -1;
        switch (type){
            case WinRatioType.BIG_WIN:
                level = 0;
                break;
            case WinRatioType.MEGA_WIN:
                level = 1;
                break;
            case WinRatioType.SUPER_MEGA_WIN:
                level = 2;
                break;
            default:
                return tl;
        }

        const winTextStart:TimelineLite = WinterHoardGameModuleConfig.winTextView.getStartAnimation(this._toRatioConfig, level);
        const count:TimelineLite = WinterHoardGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration, Linear.easeNone,[360, 420]);


        tl.add([
            winTextStart,
            count,
            WinterHoardGameModuleConfig.bigWinView.getBigWinLevelAnimation(level, type, this._toRatioConfig.duration)
        ]);

        if(this._lastLevel){
            tl.add(WinterHoardGameModuleConfig.winTextView.getEndAnimation(this._toRatioConfig, this._winLevel), tl.totalDuration());
        }
        return tl;
    }

    public abort(isActive:boolean):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        const tl:TimelineLite = new TimelineLite();
        const winText = WinterHoardGameModuleConfig.winTextView.abort(this._toRatioConfig, this._winLevel);

        WinterHoardGameModuleConfig.bigWinView.stopShake();

        let count;
        if(this._lastLevel) {
            WinterHoardGameModuleConfig.bigWinView.playEndingAnimation();
            count = WinterHoardGameModuleConfig.countUpView.abort(this._lastLevelCount);
        }
        else {
            count = WinterHoardGameModuleConfig.countUpView.abort(this._countTo);
        }

        tl.add([
            winText,
            count
        ]);

        return tl;
    }
}